import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router';
import { installerApi } from '../../utils/installerApi';
import { useInstallerSession } from '../../hooks/useInstallerSession';
import { InstallerTopbar } from './InstallerChrome';
import '../../styles/InstallerPages.css';

export default function InstallerPendingPage() {
  const nav = useNavigate();
  const { token, logout } = useInstallerSession();
  const [me, setMe] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    if (!token) { nav('/installer/login'); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const m = await installerApi.me(token);
        if (cancelled) return;
        setMe(m);
        if (m.status === 'approved') nav('/installer/dashboard');
      } catch { /* keep polling */ }
    };
    poll();
    timer.current = setInterval(poll, 30000);
    return () => { cancelled = true; clearInterval(timer.current); };
  }, [token, nav]);

  const rejected = me?.status === 'rejected';

  return (
    <div className="inst">
      <div className="inst-shell">
        <InstallerTopbar />
        <div className="inst-card">
          {rejected ? (
            <div className="inst-pending">
              <div className="inst-pulse" style={{ background: 'var(--i-error-bg)', color: 'var(--i-error)', animation: 'none' }}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="m15 9-6 6M9 9l6 6" /></svg>
              </div>
              <h1 className="inst-h1">درخواست رد شد</h1>
              <p className="inst-empty-hint">{me.rejection_reason || 'دلیلی ثبت نشده است.'}</p>
              <div style={{ marginTop: 20 }}>
                <button className="inst-btn inst-btn-ghost" onClick={() => { logout(); nav('/installer/login'); }}>خروج</button>
              </div>
            </div>
          ) : (
            <div className="inst-pending">
              <div className="inst-pulse">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
              </div>
              <h1 className="inst-h1">در انتظار تایید</h1>
              <p className="inst-empty-hint">رزومه شما ثبت شد و در حال بررسی توسط ادمین است. این صفحه به‌صورت خودکار به‌روز می‌شود.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
